if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

 connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.cookieName = 'sleektheme:popup';

        // 1. Inicializáljuk a frissítés nélküli form beküldést
        this.initAjaxForm();

        // 2. Biztonsági ellenőrzés (ha mégis újratöltődne az oldal valamiért)
        this.checkSuccessState();

        window.FoxTheme.DOMready(this.handleOpen.bind(this));

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();
            const code = target.dataset.code;
            if (code) this.copyToClipboard(code, target);
          },
        });
      }

      // ÚJ METÓDUS: Ez kezeli a háttérben történő küldést
   initAjaxForm() {
        const form = this.querySelector('form');
        if (!form) return;

        // Létrehozunk egy láthatatlan iframe-et a háttérben történő beküldéshez
        let iframe = document.getElementById('ajax-sub-iframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'ajax-sub-iframe';
          iframe.name = 'ajax-sub-iframe';
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
        }

        form.addEventListener('submit', (e) => {
          // Ha már elküldtük, ne engedjük újra
          if (this.classList.contains('submitted-success')) return;

          // Átirányítjuk a form beküldését a láthatatlan iframe-re
          form.target = 'ajax-sub-iframe';

          // Egy kis késleltetéssel váltunk nézetet, hogy a böngésző el tudja indítani a folyamatot
          setTimeout(() => {
            this.classList.add('submitted-success');
            this.setRepeatOpen();
          }, 300);

          // Itt NEM hívunk preventDefault-ot, hagyjuk, hogy a böngésző beküldje, 
          // de mivel a target az iframe, az aktuális oldal nem fog újratölteni!
        });
      }

      // 2. Itt definiáljuk, mit csináljon az ellenőrzés és a takarítás
      checkSuccessState() {
        if (window.location.search.includes('customer_posted=true')) {
          // Osztály hozzáadása a CSS-nek
          this.classList.add('submitted-success');
          
          // Elrejtjük a zavaró elemeket (cseh szöveg és egyéb popupok)
          const selectorsToHide = [
            '.form-status', 
            '.newsletter-form__message', 
            '.form-message--success',
            '[id*="Newsletter-Success"]', 
            '.modal.is-open:not(#' + this.id + ')'
          ];

          selectorsToHide.forEach(selector => {
            document.querySelectorAll(selector).forEach(el => {
              el.style.display = 'none';
              el.setAttribute('hidden', 'true');
              el.classList.remove('is-open'); 
            });
          });

          // Megnyitjuk a mi popupunkat a kuponnal
          setTimeout(() => {
            if (typeof this.show === 'function') {
              this.show();
            }
          }, 500);
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          default:
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText = button.dataset.copiedText;
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}
